import React from "react";
import style from "./css/GuideDisableMask.module.css";

export default function GuideDisableMask() {
  return <div className={style["guide-disable-mask"]}></div>;
}
